module.exports = __webpack_public_path__ + "img/imgs8.e7aed8af.png";